// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import ContactDetails from 'components/ContactDetails'

// NOTE - the key 'contactId' is hard coded here and not driven off the columnKey!

const ContactDetailsCell = ({ idRoot, rowData }) => (
  <ContactDetails
    contactId={rowData.contactId}
    idRoot={idRoot} />
)

ContactDetailsCell.propTypes = {
  idRoot: string.isRequired,
  rowData: object.isRequired,
}

export default ContactDetailsCell
